import React, { Component, Fragment } from 'react';
import { hot } from 'react-hot-loader';
import PropTypes from 'prop-types';
import { Form } from 'formik';
import { Col, Row, Card, CardBody } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import BaselineHelpOutline from 'react-md-icon/dist/BaselineHelpOutline';

import '../CreateTemplate.scss';
import { CloseButton } from '../../..';
import { esignProductTierNames } from '../../../../constants/esignProductTierNames';

const assetsBaseUrl = `${process.env.REACT_APP_DOMAIN}/assets/media`;

class TemplateType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signatureOption: this.props.startingTemplateType,
    };
  }

  componentDidMount() {
    const { signatureOption } = this.state;
    const { updateButtonLabel } = this.props;
    if (signatureOption === 'helloSign') {
      updateButtonLabel('PREPARE_DOCUMENT', 'PREPARING_DOCUMENT');
    } else {
      updateButtonLabel('UPLOAD', 'UPLOADING');
    }
  }

  enhancedEsigMessage() {
    const {
      selectedCompany,
    } = this.props;
    let content = null;
    const companyIsSimpleSign = selectedCompany.esignatureProductTier.name === esignProductTierNames.SIMPLESIGN;
    const companyIsLegacy = selectedCompany.isEsignatureLegacyCompany;
    if (companyIsSimpleSign) {
      if (companyIsLegacy) {
        content = (
          <div className="text-muted pt-2">
            <span className="note-span"><FormattedMessage id="NOTE" /></span>&nbsp;
            <FormattedMessage id="LEGACY_LIMITATIONS" />
            {/* TODO: Replace this with link to company plan page */}
            {/* <a href="google.com"> */}
            <FormattedMessage
              id="ADD_ENHANCED_ESIGNATURE"
              values={{
                startOfSentence: 'a',
              }}
            />
            {/* </a> */}
            <FormattedMessage id="TO_YOUR_PLAN" />
          </div>
        );
      } else {
        content = (
          <div className="text-muted pt-2">
            <FormattedMessage
              id="ADD_ENHANCED_ESIGNATURE"
              values={{
                startOfSentence: 'A',
              }}
            />
            <FormattedMessage id="TO_YOUR_PLAN_EXTENDED" />
          </div>
        );
      }
    }
    return content;
  }
  render() {
    const { signatureOption } = this.state;

    const {
      onClose,
      updateButtonLabel,
      toggleHelpModal,
      updateTemplateTypeValue,
      selectedCompany,
    } = this.props;

    const companyIsSimpleSign = selectedCompany.esignatureProductTier.name === esignProductTierNames.SIMPLESIGN;
    const companyIsLegacy = selectedCompany.isEsignatureLegacyCompany;
    const helloSignTemplateClasses = [];
    let helloSignIsDisabled = false;
    if (companyIsSimpleSign && !companyIsLegacy) {
      helloSignTemplateClasses.push('disabled-row', 'text-muted');
      helloSignIsDisabled = true;
    }

    return (
      <Fragment>
        <div className="modal-header pt-0 pb-4 mx-n4 px-4">
          <p className="font-weight-light h4 mb-0">
            <FormattedMessage id="ADD_DOCUMENT" />
          </p>
          <CloseButton onClick={onClose} />
        </div>
        <Row>
          <Col className="modal-label pt-3 pb-2"><FormattedMessage id="SIGNATURE_OPTIONS" /></Col>
          <Col className="reduced-text pt-3 pb-2 col-sm-4 text-right">
            <button className="btn btn-link p-0" onClick={() => toggleHelpModal(false)}>
              <BaselineHelpOutline viewBox="0 0 24 28" style={{ fontSize: '1.5rem', lineHeight: 1 }} />
              <div className="d-inline pl-1"><FormattedMessage id="HELP_ME_CHOOSE" /></div>
            </button>
          </Col>
        </Row>
        <Form>
          <Row className="signature-option-row">
            <Col>
              <Card
                className={`w-100 rounded-0 active-signature-option ${signatureOption === 'noSign' ? 'selected-signature' : ''}`}
                onClick={() => {
                  this.setState({ signatureOption: 'noSign' });
                  updateTemplateTypeValue('noSign');
                  updateButtonLabel('UPLOAD', 'UPLOADING');
                }}
              >
                <CardBody>
                  <label className="d-flex flex-row mb-0 cursor-pointer" htmlFor="noSig">
                    <Col-1>
                      <input
                        className="mt-3"
                        type="radio"
                        id="noSig"
                        name="signatureOptions"
                        value="noSign"
                        defaultChecked={signatureOption === 'noSign'}
                      />
                    </Col-1>
                    <Col-1>
                      <div className="image-wrapper">
                        <img className="pl-2" src={`${assetsBaseUrl}/no-sign.svg`} alt="No signature icon" />
                      </div>
                    </Col-1>
                    <Col className="ml-2">
                      <Row className="row-title"><FormattedMessage id="NO_SIGNATURE" /></Row>
                      <Row className="text-muted reduced-text row-body"><FormattedMessage id="SIGNATURE_NOT_REQUIRED" /></Row>
                    </Col>
                  </label>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="signature-option-row">
            <Col>
              <Card
                className={`w-100 rounded-0 active-signature-option ${signatureOption === 'simpleSign' ? 'selected-signature' : ''}`}
                onClick={() => {
                      this.setState({ signatureOption: 'simpleSign' });
                      updateTemplateTypeValue('simpleSign');
                      updateButtonLabel('UPLOAD', 'UPLOADING');
                  }}
              >
                <CardBody>
                  <label className="d-flex flex-row mb-0 cursor-pointer" htmlFor="appendSig">
                    <Col-1>
                      <input
                        className="mt-4"
                        type="radio"
                        id="appendSig"
                        name="signatureOptions"
                        value="simpleSign"
                        defaultChecked={signatureOption === 'simpleSign'}
                      />
                    </Col-1>
                    <Col-1>
                      <div className="image-wrapper">
                        <img className="pl-2 mt-1" src={`${assetsBaseUrl}/simple-sign.svg`} alt="Simple E-Signature icon" />
                      </div>
                    </Col-1>
                    <Col className="ml-2">
                      <Row className="row-title"><FormattedMessage id="SIMPLE_ESIGNATURE" /></Row>
                      <Row className="text-muted reduced-text row-body"><FormattedMessage id="SIMPLE_ESIGNATURE_MESSAGE" /></Row>
                    </Col>
                  </label>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className={helloSignTemplateClasses.join(' ')}>
            <Col>
              {/* we might use this tooltip again */}
              {/* <span data-tip data-for="toolTip" data-tip-disable={!(!this.state.isOnboardingDoc && companyIsLegacy && companyIsSimpleSign)}> */}
              <Card
                className={`w-100 rounded-0
                  ${signatureOption === 'helloSign' ? ' selected-signature' : ''}
                  ${helloSignIsDisabled ? '' : ' active-signature-option'}`}
                onClick={() => {
                  if (!helloSignIsDisabled) {
                      this.setState({ signatureOption: 'helloSign' });
                      updateTemplateTypeValue('helloSign');
                      updateButtonLabel('PREPARE_DOCUMENT', 'PREPARING_DOCUMENT');
                    }
                  }}
              >
                <CardBody>
                  <label className="d-flex flex-row mb-0 cursor-pointer" htmlFor="configureSig">
                    <Col-1>
                      <input
                        className="mt-4"
                        type="radio"
                        id="configureSig"
                        name="signatureOptions"
                        value="helloSign"
                        defaultChecked={signatureOption === 'helloSign' && !helloSignIsDisabled}
                        disabled={helloSignIsDisabled}
                      />
                    </Col-1>
                    <Col-1>
                      <div className="image-wrapper">
                        <img
                          className={`pl-2 mt-1 ${helloSignIsDisabled ? 'disabled-text' : ''}`}
                          src={`${assetsBaseUrl}/enhanced-sign.svg`}
                          alt="Enhanced E-Signature icon"
                        />
                      </div>
                    </Col-1>
                    <Col className="ml-2">
                      <Row className={`row-title ${helloSignIsDisabled ? 'disabled-text' : ''}`}><FormattedMessage id="ENHANCED_ESIGNATURE" /></Row>
                      <Row
                        className="row-body reduced-text"
                      >
                        <div className={`${helloSignIsDisabled ? 'disabled-text' : 'text-muted'}`}>
                          <FormattedMessage id="ENHANCED_ESIGNATURE_MESSAGE" />
                        </div>
                        {this.enhancedEsigMessage()}
                      </Row>
                    </Col>
                  </label>
                </CardBody>
              </Card>
              {/* </span> */}
              {/* <ReactTooltip id="toolTip" place="bottom" effect="solid">
                <FormattedMessage id="SIGNATURE_TEMPLATE_TOOLTIP" />
              </ReactTooltip> */}
            </Col>
          </Row>
        </Form>
      </Fragment>
    );
  }
}

TemplateType.defaultProps = {
  startingTemplateType: 'noSign',
};
TemplateType.propTypes = {
  onClose: PropTypes.func.isRequired,
  updateButtonLabel: PropTypes.func.isRequired,
  toggleHelpModal: PropTypes.func.isRequired,
  updateTemplateTypeValue: PropTypes.func.isRequired,
  startingTemplateType: PropTypes.string,
  selectedCompany: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    esignatureProductTier: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    isEsignatureLegacyCompany: PropTypes.bool,
  }).isRequired,
};

export default hot(module)(TemplateType);



// WEBPACK FOOTER //
// ./src/components/Forms/CreateTemplate/TemplateType/TemplateType.jsx